import React, { useContext } from 'react';
import styles from './GoogleMapEmbed.module.css';
import ContentContainer from '../ReusableComponents/ContentContainer/ContentContainer';
import PanelSection from '../ReusableComponents/PanelSection/PanelSection';
import ThemeContext from '../../contexts/ThemeContext';
import walkImage from './walk.png';
import HeroSection from '../ReusableComponents/HeroSection/HeroSection';

const GoogleMapEmbed = () => {
  const { primaryFont, secondaryFont } = useContext(ThemeContext);

  const primaryFontStyle = {
    fontFamily: primaryFont,
  };

  const secondaryFontStyle = {
    fontFamily: secondaryFont,
  };

  return (
    <div className={styles.GoogleMapEmbed} data-testid={'GoogleMapEmbed'}>
      <ContentContainer>
        <div className={styles.header}>
          <h4 style={primaryFontStyle}>Directions</h4>
          <p style={secondaryFontStyle}>
            Navigate your way to success with our interactive map, guiding you
            towards new opportunities, exciting destinations, and limitless
            possibilities.
          </p>
        </div>
        <PanelSection className={styles.mapContainer}>
          <HeroSection
            contentSection={
              <div className={styles.imageContainer}>
                <img src={walkImage} alt="Location" />
              </div>
            }
            imageSection={
              <iframe
                title="Google-Map-Embed"
                src="https://maps.google.com/maps?q=79+Block+G2+Johar+Town%2C+Lahore%2C+54000&output=embed"
                style={{ border: 0 }}
                loading="lazy"
              ></iframe>
            }
          />
          <div style={{ display: 'flex', gap: '1em' }}></div>
        </PanelSection>
      </ContentContainer>
    </div>
  );
};

export default GoogleMapEmbed;
